import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import albumPhotoReducer from "./slices/albumPhoto";
import albumReducer from "./slices/albums";
import cartReducer from "./slices/cart";
import contestantReducer from "./slices/contestants";
import dashboardReducer from "./slices/dashboard";
import ecommerceReducer from "./slices/ecommerce";
import menuReducer from "./slices/menu";
import packageReducer from "./slices/packages";
import snackbarReducer from "./slices/snackbar";
import superAthletesReducer from "./slices/superathletes";
import tagsReducer from "./slices/tags";
// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  snackbar: snackbarReducer,
  albums: albumReducer,
  albumPhoto: albumPhotoReducer,
  contestants: contestantReducer,
  ecommerce: ecommerceReducer,
  dashboard: dashboardReducer,
  superathletes: superAthletesReducer,
  menu: menuReducer,
  cart: persistReducer(
    {
      key: "cart",
      storage,
      keyPrefix: "eventpxl-",
    },
    cartReducer
  ),
  tags: tagsReducer,
  packages: packageReducer,
});

export default reducer;
